import {useCallback, useState} from 'react';
import {type AstView} from 'rendition-core';

import {useNodeNameEdit} from './useNodeNameEdit';

export const useRegroupingStep = ({
    view,
    flexNodes,
    absPositionNodes,
    onGetCode,
}: {
    view: AstView;
    flexNodes: Array<string>;
    absPositionNodes: Array<string>;
    onGetCode: () => void;
}) => {
    const [loadingCode, setLoadingCode] = useState(false);

    const doGetCode = useCallback(() => {
        setLoadingCode(true);
        onGetCode();
    }, [onGetCode]);

    const {jumpToEditNextNode} = useNodeNameEdit(view, flexNodes, absPositionNodes);

    return {
        loadingCode,
        setLoadingCode,
        jumpToEditNextNode,
        doGetCode,
    };
};
